import React, { memo } from 'react'

import {
  Button, ChevronDown, ChevronRight, Icon, Paint, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const paintIcon = <Icon svgComponent={Paint} size={iconSize} notSpaced />
const chevronDownIcon = <Icon svgComponent={ChevronDown} size={iconSize} notSpaced />
const chevronRightIcon = <Icon svgComponent={ChevronRight} size={iconSize} notSpaced />

// Placeholder trigger: the Style modal it will open is built in a separate task.
function StyleButton({ isStacked = false }) {
  const t = useTranslation()

  return (
    <Button
      type="secondary"
      size="small"
      variant="with-icon"
      actionType="button"
      icon={paintIcon}
      trailIcon={isStacked ? chevronRightIcon : chevronDownIcon}
      customClass={classnames(
        'style-button cgt-button-text-base-semibold',
        isStacked && 'style-button--stacked',
      )}
    >
      {t('imageAssistantPanel.createTab.composer.style')}
    </Button>
  )
}

StyleButton.propTypes = {
  isStacked: bool,
}

export default memo(StyleButton)
